import React from "react"
import { jsx } from "@emotion/react"

export type CustomRadioButtonProps = {
  index: number
  // className?: string
  labelTitle: string
  name: string
  value: string
  recordState: string | number
  handleChange: (value: string) => void
  isDisabled?: boolean
} & React.HTMLProps<any>

function CustomRadioButton(props: CustomRadioButtonProps) {
  const {
    index, recordState, value, handleChange, labelTitle, name, isDisabled = false
  } = props
  return (
    <div className="flex items-center p-1">
      <input
        type="radio" id={`r-${name}-${index}`}
        name={name} value={value}
        checked={recordState == value} // Controlled by state
        onChange={(e) =>
          handleChange(e.target.value)
        } // Updates state
        className="cursor-pointer"
        disabled={isDisabled}
      />
      <label
        htmlFor={`r-${name}-${index}`}
        className="ml-3 block text-gray4 cursor-pointer">
        {labelTitle}
      </label>
    </div>
  )
}

export default CustomRadioButton